module.exports = __webpack_public_path__ + "img/collection-engagementRingsEntwined.d42f757.webp";